const BANNER_CDN = () =>
    Boolean(sessionStorage.getItem('hideCdnBanner') === 'true')
        ? 0
        : (
              document.querySelector(
                  'ds-uilab-banner.cdn-banner',
              ) as HTMLElement
          )?.getBoundingClientRect()?.height;

export const GET_GAP = () =>
    (
        document.querySelector('app-appbar') as HTMLElement
    )?.getBoundingClientRect()?.height + BANNER_CDN();
